"use client";

import { c as _c } from "react/compiler-runtime";
import { CropSquare, Search, Visibility, VisibilityOff } from "@mui/icons-material";
import { FormGroup, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import { IMaskInput } from "react-imask";
import styled, { useTheme } from "styled-components";
import { inputIcons } from "./types";

// Komponenty pomocnicze

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const $ = _c(13);
  let mask;
  let onChange;
  let other;
  if ($[0] !== props) {
    ({
      onChange,
      mask,
      ...other
    } = props);
    $[0] = props;
    $[1] = mask;
    $[2] = onChange;
    $[3] = other;
  } else {
    mask = $[1];
    onChange = $[2];
    other = $[3];
  }
  let t0;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      "#": /[0-9]/
    };
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== onChange || $[6] !== props.name) {
    t1 = value => onChange?.({
      target: {
        name: props.name,
        value
      }
    });
    $[5] = onChange;
    $[6] = props.name;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== mask || $[9] !== other || $[10] !== ref || $[11] !== t1) {
    t2 = <IMaskInput {...other} mask={mask} definitions={t0} inputRef={ref} onAccept={t1} overwrite={true} />;
    $[8] = mask;
    $[9] = other;
    $[10] = ref;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
});

// Funkcja pomocnicza dla ikon
const getIcon = iconVariant => {
  switch (iconVariant) {
    case inputIcons.SEARCH:
      return <Search />;
    default:
      return <CropSquare />;
  }
};

// Główny komponent
const Input = t0 => {
  const $ = _c(64);
  const {
    label,
    focused,
    id,
    value,
    defaultValue,
    icon,
    iconVariant,
    iconPosition,
    iconGreyColored,
    name,
    placeholder,
    onChange,
    onKeyDown,
    error,
    errorHelper,
    helperText,
    validated,
    multiline,
    rows,
    disabled,
    autoComplete,
    onClick,
    type: t1,
    autoFocus: t2,
    mask,
    max,
    min,
    variant,
    className,
    onBlur
  } = t0;
  const type = t1 === undefined ? "text" : t1;
  const autoFocus = t2 === undefined ? false : t2;
  const theme = useTheme();
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";
  const actualType = isPassword ? showPassword ? "text" : "password" : type;
  let t3;
  if ($[0] !== icon || $[1] !== iconGreyColored || $[2] !== iconPosition || $[3] !== iconVariant || $[4] !== isPassword || $[5] !== showPassword) {
    t3 = position => {
      if (!icon || iconPosition !== (position === "start" ? "left" : "right")) {
        return null;
      }
      if (position === "end" && isPassword) {
        return <StyledInputAdornment $iconPosition="right" $greyColored={iconGreyColored} position="end" onClick={() => setShowPassword(!showPassword)}>{showPassword ? <VisibilityOff /> : <Visibility />}</StyledInputAdornment>;
      }
      return <StyledInputAdornment $iconPosition={iconPosition} $greyColored={iconGreyColored} position={position}>{getIcon(iconVariant)}</StyledInputAdornment>;
    };
    $[0] = icon;
    $[1] = iconGreyColored;
    $[2] = iconPosition;
    $[3] = iconVariant;
    $[4] = isPassword;
    $[5] = showPassword;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const renderAdornment = t3;
  const t4 = error === true;
  const t5 = validated === true;
  const t6 = variant === "backgroundOnly";
  let t7;
  if ($[7] !== error || $[8] !== errorHelper) {
    t7 = error && errorHelper && <ErrorFormHelperText>{errorHelper}</ErrorFormHelperText>;
    $[7] = error;
    $[8] = errorHelper;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = variant === "backgroundOnly" ? 0 : 1;
  const t9 = error ? theme.colors.ERROR_500 : validated ? theme.colors.SPECIAL_600 : theme.colors.GRAYSCALE_300;
  let t10;
  if ($[10] !== t8 || $[11] !== t9) {
    t10 = {
      borderBottomWidth: t8,
      borderBottomColor: t9
    };
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const t11 = variant === "backgroundOnly" ? 0 : 1;
  let t12;
  if ($[13] !== t11) {
    t12 = {
      borderBottomWidth: t11
    };
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t10 || $[16] !== t12) {
    t13 = {
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": t10,
      "& .MuiInput-underline:not(.Mui-disabled):before": t12
    };
    $[15] = t10;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== renderAdornment) {
    t14 = renderAdornment("start");
    $[18] = renderAdornment;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== renderAdornment) {
    t15 = renderAdornment("end");
    $[20] = renderAdornment;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  const t16 = mask ? TextMaskCustom : undefined;
  let t17;
  if ($[22] !== mask || $[23] !== max || $[24] !== min || $[25] !== name) {
    t17 = {
      mask,
      name,
      min,
      max
    };
    $[22] = mask;
    $[23] = max;
    $[24] = min;
    $[25] = name;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t14 || $[28] !== t15 || $[29] !== t16 || $[30] !== t17) {
    t18 = {
      startAdornment: t14,
      endAdornment: t15,
      inputComponent: t16,
      inputProps: t17
    };
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== actualType || $[33] !== autoComplete || $[34] !== autoFocus || $[35] !== defaultValue || $[36] !== disabled || $[37] !== error || $[38] !== focused || $[39] !== id || $[40] !== label || $[41] !== multiline || $[42] !== name || $[43] !== onBlur || $[44] !== onChange || $[45] !== onClick || $[46] !== onKeyDown || $[47] !== placeholder || $[48] !== rows || $[49] !== t13 || $[50] !== t18 || $[51] !== value) {
    t19 = <TextField label={label} placeholder={placeholder} id={id} autoFocus={autoFocus} value={value} defaultValue={defaultValue} name={name} onChange={onChange} variant="standard" error={error} focused={focused} type={actualType} multiline={multiline} rows={rows} disabled={disabled} onKeyDown={onKeyDown} autoComplete={autoComplete} onBlur={onBlur} onClick={onClick} sx={t13} InputProps={t18} />;
    $[32] = actualType;
    $[33] = autoComplete;
    $[34] = autoFocus;
    $[35] = defaultValue;
    $[36] = disabled;
    $[37] = error;
    $[38] = focused;
    $[39] = id;
    $[40] = label;
    $[41] = multiline;
    $[42] = name;
    $[43] = onBlur;
    $[44] = onChange;
    $[45] = onClick;
    $[46] = onKeyDown;
    $[47] = placeholder;
    $[48] = rows;
    $[49] = t13;
    $[50] = t18;
    $[51] = value;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== helperText) {
    t20 = helperText && <InfoFormHelperText><div dangerouslySetInnerHTML={{
        __html: helperText
      }} /></InfoFormHelperText>;
    $[53] = helperText;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== className || $[56] !== disabled || $[57] !== t19 || $[58] !== t20 || $[59] !== t4 || $[60] !== t5 || $[61] !== t6 || $[62] !== t7) {
    t21 = <StyledFormGroup className={className} $disabled={disabled} $error={t4} $validated={t5} $backgroundOnly={t6}>{t7}{t19}{t20}</StyledFormGroup>;
    $[55] = className;
    $[56] = disabled;
    $[57] = t19;
    $[58] = t20;
    $[59] = t4;
    $[60] = t5;
    $[61] = t6;
    $[62] = t7;
    $[63] = t21;
  } else {
    t21 = $[63];
  }
  return t21;
};

// Pomocnicze komponenty
const ErrorFormHelperText = styled.div`
  position: absolute;
  bottom: -20px;
  left: 0;
  color: ${({
  theme
}) => theme.colors.ERROR_500} !important;
  line-height: 20px;
  text-align: right !important;

  // FormHelperText
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  margin-top: 3px;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
`;
const InfoFormHelperText = styled.div`
  line-height: 20px;
  color: ${({
  theme
}) => theme.colors.GRAYSCALE_500} !important;

  // FormHelperText
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  margin-top: 3px;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
`;
const StyledInputAdornment = styled(InputAdornment)`
  height: 36px !important;
  width: 46px !important;
  max-height: 46px !important;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 !important;

  svg {
    color: ${({
  theme,
  $greyColored
}) => $greyColored ? theme.colors.GRAYSCALE_500 : theme.colors.GRAYSCALE_800} !important;
  }

  ${({
  $iconPosition,
  theme
}) => $iconPosition === "left" && `
    border-radius: ${theme.radii.default} 0 0 ${theme.radii.default};
  `}

  ${({
  $iconPosition,
  theme
}) => $iconPosition === "right" && `
    border-radius: 0 ${theme.radii.default} ${theme.radii.default} 0;
  `}
`;
const StyledFormGroup = styled(FormGroup)`
  position: relative;
  font-family: "Nunito Sans", sans-serif !important;

  ${({
  theme,
  $backgroundOnly
}) => $backgroundOnly && `
    background-color: ${theme.colors.GRAYSCALE_100} !important;
    padding: 5px 0;
  `}

  .MuiInputBase-input {
    min-height: 26px !important;
    max-height: 140px !important;
    overflow: auto !important;
    font-size: ${({
  theme
}) => theme.fontSizes.m} !important;
  }

  .MuiInputBase-root {
    background-color: transparent !important;
    color: ${({
  theme
}) => theme.colors.GRAYSCALE_900};

    ${({
  theme,
  $validated
}) => $validated && `
      caret-color: ${theme.colors.SPECIAL_600};
      
      &:before {
       border-bottom: 1px solid ${theme.colors.SPECIAL_500} !important;
      }
    `}

    input {
      &::placeholder {
        color: ${({
  theme
}) => theme.colors.GRAYSCALE_700};
        font-family: "Nunito Sans", sans-serif !important;
        font-weight: 600 !important;
      }
    }

    ${({
  $disabled,
  $validated,
  $error,
  theme,
  $backgroundOnly
}) => !$disabled && `
    &:focus,
    &:active,
    &:hover {
      border-bottom: none !important;
      background-color: ${theme.colors.WHITE};
      ${!$validated && !$error && !$backgroundOnly && `border: 1px solid ${theme.colors.GRAYSCALE_300}`}
      ${$validated && "box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1FADF"}
      ${$error && "box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #FEE4E2"}
    }
    `}

    &:after {
      border: none !important;
    }

    & .MuiInputBase-input {
      color: ${({
  theme
}) => theme.colors.BLACK};

      ${({
  theme,
  $validated
}) => $validated && `
      color: ${theme.colors.SPECIAL_600};
    `}

      ${({
  theme,
  $error
}) => $error && `
      color: ${theme.colors.ERROR_500};
    `}

      &::placeholder {
        color: ${({
  theme
}) => theme.colors.BLACK};
      }
    }

    .MuiInputAdornment-root {
      margin: 0 !important;
      color: ${({
  theme
}) => theme.colors.BLACK};
    }
  }

  .Mui-focused {
    color: rgba(0, 0, 0, 0.6) !important;
  }

  .Mui-error {
    border-bottom: none !important;
    caret-color: ${({
  theme
}) => theme.colors.ERROR_500};
  }

  .Mui-disabled {
    background-color: ${({
  theme
}) => theme.colors.GRAYSCALE_50} !important;
    color: ${({
  theme
}) => theme.colors.GRAYSCALE_300};
    cursor: not-allowed;
  }
`;
export default Input;